@if (isHelpFaqWidgetEnabled()) {
  <app-faq-menu-link></app-faq-menu-link>
}

<a appTrackedLink
   data-testid="help-tech-support-link"
   [trackId]="'header:help:tech-support'"
   [trackType]="'inbound_call_number'"
   mat-menu-item
   class="rkt-menu__item help-item"
   [href]="telHref(techSupportPhoneNumber)"
   [title]="'header.HELP_MENU.TECH_ASSISTANCE_TITLE' | translate">
  <nova-icon name="phone_in_talk" [title]="'header.HELP_MENU.TECH_ASSISTANCE_TITLE' | translate"></nova-icon>
  <span class="help-details">
    <span class="help-number">{{ techSupportPhoneNumber }}</span>
    <span class="help-label">{{ "header.HELP_MENU.TECH_ASSISTANCE_TITLE" | translate }}</span>
    <span class="help-hours">
      {{ "header.HELP_MENU.TECH_ASSISTANCE_HOURS_WEEKDAY" | translate }}<br />
      {{ "header.HELP_MENU.TECH_ASSISTANCE_HOURS_SATURDAY" | translate }}
    </span>
  </span>
</a>
<a appTrackedLink
   data-testid="help-doc-loan-link"
   [trackId]="'header:help:doc-loan'"
   [trackType]="'inbound_call_number'"
   mat-menu-item
   class="rkt-menu__item help-item"
   [href]="telHref(documentAndLoanPhoneNumber)"
   [title]="'header.HELP_MENU.DOC_LOAN_TITLE' | translate">
  <nova-icon name="phone_in_talk" [title]="'header.HELP_MENU.DOC_LOAN_TITLE' | translate"></nova-icon>
  <span class="help-details">
    <span class="help-number">{{ documentAndLoanPhoneNumber }}</span>
    <span class="help-label">{{ "header.HELP_MENU.DOC_LOAN_TITLE" | translate }}</span>
    <span class="help-hours" data-testid="help-doc-loan-hours">
      {{ "header.HELP_MENU.DOC_LOAN_HOURS_WEEKDAY" | translate }}<br />
      {{ "header.HELP_MENU.DOC_LOAN_HOURS_SATURDAY" | translate }}
    </span>
  </span>
</a>
